export enum DeathType {
  natural = 'N',
  judicial = 'J'
}
